import React from "react";
import PropTypes from "prop-types";
import { Description, Text } from "@learningblocks/storybook-components";

/**
 * SlideDescription
 *  - Component renders the description for displaying
 *    slide in scrollables
 */
export function SlideDescription(props) {
  function renderDescription(item, key) {
    return (
      <Description
        key={key}
        percentage={props.scrollTip}
        minRange={item.props.minRange}
        maxRange={item.props.maxRange}
        ariaLabel={item.props.description}
        id={item.props.id}
      >
        <Text
          description={item.props.description}
          percentage={props.scrollTip}
          highlights={item.props.highlights}
        />
      </Description>
    );
  }

  function renderDescriptions() {
    return props.descriptionList.map(renderDescription);
  }

  return <div>{renderDescriptions()}</div>;
}

SlideDescription.propTypes = {
  /**
   * List of descriptions entities.
   */
  descriptionList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      minRange: PropTypes.number,
      maxRange: PropTypes.number,
      highlights: PropTypes.arrayOf(
        PropTypes.shape({
          string: PropTypes.string,
          minRange: PropTypes.number,
          maxRange: PropTypes.number,
        })
      ),
    })
  ),
  /**
   * Number value specifying current scroll tip.
   */
  scrollTip: PropTypes.number,
};
